import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "../lib/motion";
import { FAQ as FAQ_DATA } from "../data";

export const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative border-t border-black/10 bg-[#f4f4f1] py-28 md:py-36" data-testid="faq-section">
      <div className="container-vx grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-20">
        <div className="lg:col-span-4">
          <Reveal>
            <span className="label-mono">/ Questions</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-sans text-4xl font-light leading-tight tracking-tight md:text-5xl">
              Everything you were about to ask.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 font-body text-neutral-600">
              Still curious? A 30-minute strategy call answers the rest.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          {FAQ_DATA.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border-b border-black/10" data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="group flex w-full items-center justify-between gap-6 py-7 text-left"
                  data-testid={`faq-trigger-${i}`}
                  aria-expanded={isOpen}
                >
                  <span className="font-sans text-xl font-medium tracking-tight transition-colors duration-300 group-hover:text-black md:text-2xl">
                    {item.q}
                  </span>
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-black/15 transition-all duration-400 ${
                      isOpen ? "rotate-45 border-[var(--accent)]/50 text-[var(--accent)]" : "text-neutral-500"
                    }`}
                  >
                    <Plus className="h-4 w-4" />
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="max-w-2xl pb-8 font-body text-lg leading-relaxed text-neutral-600">
                        {item.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
